import React, { useEffect, useState } from 'react';
import dataAids from '../../../../constants/dataAids';
import { UX2 } from '@wsb/guac-widget-core';
import PropTypes from 'prop-types';
import { errorMessageProps } from '../../../../constants/constants';
import * as Metrics from '../../utils/trackMetric';
import * as MetricEvents from '../../../../constants/metrics';
import { getIsLowInventoryInGallery } from './lowInventoryHelper';

const InventoryWarning = props => {
  const {
    product,
    translate,
    priceTable,
    selectedVariant,
    productErrorMessages,
    isSelectedVariantInStock,
    isLowInventoryInGalleryEnabled,
    isQuickView,
    isGalleryDetail
  } = props;

  const lowInventoryThreshold = product?.low_inventory_threshold || 3;
  const isLowInventoryInGallery = getIsLowInventoryInGallery(product);
  const variantData = priceTable[selectedVariant] || {};
  const quantityErrors = productErrorMessages('quantity');
  const styles = {
    error: {
      marginBottom: 'small'
    }
  };

  const [lowInventoryText, setLowInventoryText] = useState('');
  const [metricWasTracked, setMetricWasTracked] = useState(false);

  useEffect(() => {
    if (
      isLowInventoryInGallery ||
      (variantData.totalOnHand <= lowInventoryThreshold && variantData.totalOnHand > 0)
    ) {
      if (isLowInventoryInGalleryEnabled && !isQuickView && !metricWasTracked) {
        Metrics.track(MetricEvents.PRODUCT_LIST_LOW_IN_STOCK_IMPRESSION);
        setMetricWasTracked(true);
      }
      setLowInventoryText(translate('products.item_low_quantity_almost_gone'));
    }
  }, [
    variantData,
    lowInventoryThreshold,
    translate,
    isLowInventoryInGallery,
    isLowInventoryInGalleryEnabled,
    isQuickView,
    metricWasTracked
  ]);

  if (
    !product ||
    !product.track_inventory ||
    variantData?.totalOnHand > lowInventoryThreshold ||
    (!isLowInventoryInGalleryEnabled && isGalleryDetail)
  ) {
    return null;
  }

  if (quantityErrors.length) {
    return <UX2.Element.Error { ...errorMessageProps } children={ quantityErrors[0] } />;
  } else if (!isSelectedVariantInStock && !product.backorderable) {
    return (
      <UX2.Element.Error
        { ...errorMessageProps }
        data-aid={ dataAids.OUT_OF_STOCK }
        children={ translate('products.item_out_of_stock_v2') }
        style={ styles.error }
      />
    );
  } else if (
    isLowInventoryInGallery ||
    (variantData.totalOnHand <= lowInventoryThreshold && variantData.totalOnHand > 0)
  ) {
    return (
      <UX2.Element.Error
        { ...errorMessageProps }
        data-aid={ dataAids.LOW_INVENTORY_ALERT_RENDERED }
        children={ lowInventoryText }
        style={ styles.error }
      />
    );
  }

  return null;
};

InventoryWarning.propTypes = {
  product: PropTypes.object,
  translate: PropTypes.func,
  priceTable: PropTypes.object,
  selectedVariant: PropTypes.number,
  productErrorMessages: PropTypes.func,
  isSelectedVariantInStock: PropTypes.bool,
  isLowInventoryInGalleryEnabled: PropTypes.bool,
  isQuickView: PropTypes.bool,
  isGalleryDetail: PropTypes.bool
};

export default InventoryWarning;
